const JP = {
    "1": "簡体中文",
    "2": "繁体中文",
    "3": "英語",
    "4": "Login",
    "5": "ALL",
    "6": "News",
    "7": "大会情報",
    "8": "Activity",
    "9": "Information",
    "10": "New Shop",
    "11": "News List",
    "12": "Shop List",
    "13": "Shop Activities",
    "14": "製品情報",
    "15": "SNS",
    "16": "Recent results",
    "17": "Change items",
    "18": "Exit",
    "19": "確定",
    "20": "My Page",
    "21": "Overall Data",
    "22": "Game Information",
    "23": "Home Shop",
    "24": "Friends chat",
    "25": "その他の設定",
    "26": "Account",
    "27": "Password",
    "28": "Forgot account number",
    "29": "Forgot password",
    "30": "新規登録",
    "31": "Country/Region",
    "32": "言語",
    "33": "会員情報",
    "34": "ID",
    "35": "Card Number",
    "36": "Password",
    "37": "Password確認",
    "38": "ニックネーム",
    "39": "Email",
    "40": "6-20字の英字または数字を入力してください",
    "41": "パスワードは6文字以上20文字以内です",
    "42": "EmailでAdartsアカウントを認証してください",
    "43": "Necessary game information",
    "44": "Name",
    "45": "性別",
    "46": "SMS",
    "47": "生年月日",
    "48": "携帯電話番号",
    "49": "Adartsが開催する大会に参加するには、以下の情報が必要です",
    "50": "以下の情報と、確認Emailを入力後すぐにアイテムを使用可能となります",
    "51": "メッセージ受信を許可",
    "52": "メッセージ受信を拒否",
    "53": "男性",
    "54": "女性",
    "55": "メール設定",
    "56": "[登録]をクリックする事で、Adarts利用規約に同意し、クッキー使用を含む個人情報取り扱いポリシーを理解したものと致します",
    "57": "登録",
    "58": "Forgot account ID",
    "59": "verification codeを送信する",
    "60": "Adarts account password",
    "61": "Adarts account email",
    "62": "Adarts account ID",
    "63": "Please enter the correct format!",
    "64": "Last 30 game results",
    "65": "Award Data",
    "66": "Chat Content",
    "67": "Friends List",
    "68": "新規友達追加",
    "69": "Adarts Card 設定",
    "70": "アカウント情報設定",
    "71": "Award メッセージ設定",
    "72": "アイテム設定",
    "73": "パスワード設定",
    "74": "Bull 数",
    "75": "01 総ゲーム数/勝率",
    "76": "Cricket 総ゲーム数/勝率",
    "77": "総ゲーム数/勝率",
    "78": "Count Up 平均点",
    "79": "Count Up 最高得点",
    "80": "最高得点",
    "81": "Bull 命中率",
    "82": "S-Bull 命中率",
    "83": "D-Bull 命中率",
    "84": "Triple 命中率",
    "85": "01 Fastest darts finish ",
    "86": "usernameを入力してください",
    "87": "passwordを入力してください",
    "88": "Verification code",
    "89": "verification codeを入力してください",
    "90": "email addressを入力してください",
    "91": "account numberを入力してください",
    "92": "All",
    "93": "Friend",
    "94": "Close friends",
    "95": "Operation",
    "96": "カードコピー",
    "97": "消去",
    "98": "card追加",
    "99": "(Country/Region)/Language",
    "100": "カード登録日",
    "101": "テーマ設定",
    "102": "Image",
    "103": "複数のAWARDメッセージを登録した場合、 それぞれのカードを使用した際に表示されます",
    "104": "AWARD 情報",
    "105": "Information",
    "106": "AWARD",
    "107": "このページでパスワードを変更することが出来ます。新しいパスワードは、card ID と account IDに適用されます",
    "108": 'Old password',
    "109": 'New password',
    "110": 'Passwords が一致しません ',
    "111": 'Adarts shop homepage',
    "112": 'Adarts search shop',
    "113": 'ショップテーマが設定されました',
    "114": 'New Shop',
    "115": '地域選択',
    "116": "Today's game information",
    "117": 'Recommendation',
    "118": 'Player list',
    "119": 'Rank',
    "120": 'Search Shop',
    "121": 'Customer Service',
    "122": '7日以内に対戦したプレーヤー',
    "123": 'New',
    "124": 'Accept',
    "125": 'Copy successful',
    "126": '消去しますか？ ',
    "127": 'Cancel',
    "128": '今月',
    "129": '回数',
    "130": 'ログインして My pageを確認してください ',
    "131": 'Verification 方法',
    "132": 'No data',
    "133": 'Countdown:',
    "134": '新しいパスワードを入力してください',
    "135": 'My Page',
    "136": 'Item Shop',
    "137": 'Adarts shop',
    "138": 'Mission Reward',
    "139": '選手紹介',
    "140": 'Dart specifications',
    "141": '大会結果',
    "142": 'Player videos',
    "143": '関連商品',
    "144": 'メインカードに設定する',
    "145": 'A1 machine',
    "146": 'W1 machine',
    "147": 'View map',
    "148": 'Theme style',
    "149": '営業時間',
    "150": '店休日',
    "151": '住所',
    "152": 'アクセス情報',
    "153": '予算',
    "154": 'テーマ',
    "155": 'Service',
    "156": 'URL',
    "157": 'Tournament ランキング',
    "158": 'Items Shop',
    "159": 'Darts コラム',
    "160": 'Shop Message',
    "161": "Player's Card",
    "162": 'ホームページ',
    "163": 'My Item',
    "164": 'Item 購入',
    "165": 'Item Store 検索',
    "166": 'My Settings',
    "167": 'My item list',
    "168": 'アイテム交換',
    "169": 'おすすめアイテム',
    "170": 'New Item',
    "171": 'Item ランキング',
    "172": 'Item / gold 交換',
    "173": 'テンプレート選択',
    "174": 'Save Settings',
    "175": 'Style 設定',
    "176": '使用中アイテム',
    "177": 'Award 設定',
    "178": '更新',
    "179": 'Items選択',
    "180": 'アイテムの使用期間を延長すると、取り消すことは出来ません',
    "181": '交換したGold 数',
    "182": '現在の Gold 数',
    "183": '合計 Gold 数',
    "184": 'Item 詳細',
    "185": 'Gold owned',
    "186": 'Give present',
    "187": 'Request a gift',
    "188": '購入確認',
    "189": '購入してすぐに使用する',
    "190": 'Buy',
    "191": 'What is GOLD?',
    "192": 'Gold 獲得方法',
    "193": 'What is Item Shop?',
    "194": 'Sort Gold Item & Item Type',
    "195": 'Purchase Item & Custom(Item settings and cancellation)',
    "196": '最近の対戦相手',
    "197": '選択',
    "198": 'Last play time (days)',
    "199": 'フレンドリクエストが送信されました',
    "200": 'Award Ranking',
    "201": '進行中',
    "202": '終了',
    "203": 'Host Shop',
    "204": 'Activity Date',
    "205": 'Dart Machine',
    "206": '参加方法',
    "207": 'Contact Information',
    "208": 'Tournament Time',
    "209": 'Request Present',
    "210": 'Activity Description',
    "211": 'How to participate',
    "212": '参加費用',
    "213": 'エントリーフィー',
    "214": 'Reward',
    "215": 'Others',
    "216": 'Not yet started',
    "217": 'Present Box',
    "218": 'Received Present',
    "219": 'Received Present Request',
    "220": 'Gift friend',
    "221": 'Time of gift',
    "222": 'Accept All',
    "223": 'Sort by purchase time',
    "224": 'Sort the order of purchase time',
    "225": '※ Item の下に購入日時が表示されます',
    "226": 'Deducted gold',
    "227": 'テンプレートは10件まで保存できます',
    "228": 'テンプレートを保存するには、不必要なテンプレートを消去してください',
    "229": 'テンプレートの名前を入力してください',
    "230": 'テンプレートを使用しないでください',
    "231": 'Agree',
    "232": 'Decline',
    "233": 'Request Time',
    "234": 'Shop Type',
    "235": '最高連勝',
    "236": '日本語',
    "237": '新しいカード番号を入力してください',
    "238": ' カードコピーを行う際は、新しいカードを使用してください。カードコピーした後、以前のカードは使用できなくなります。 ',
    "239": '送信',
    "240": 'アカウント名 / パスワードを忘れた場合',
};
export default JP;